<template>
  <div class="game">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page fiche-jeu">
      <div class="grid-x grid-margin-x">
        <div class="small-12 cell">
          <title-page attrpage="Mini jeux" baseline="À toi de jouer !">Prise de sang – Pose de Cathéter - Pansement</title-page>

          <p>La <strong>prise de sang</strong> consiste à prendre une petite partie de ton sang pour compter et analyser
          les cellules contenues à l’intérieur. C’est un bon indicateur de ton état de santé pour l’équipe
          soignante.<br>
          Le prélèvement est fait avec une seringue après avoir désinfecté ta peau au niveau d’une
          veine, par exemple au pli du bras. Un peu de sang va passer de tes veines dans un tube qui
          est ensuite envoyé dans un laboratoire pour l’étudier. Tu n’auras pas mal car on va te mettre
          de la crème anesthésiante avant de piquer ta peau.<br>
          Après la prise de sang, on appuie un peu sur l’endroit qui a été piqué et on te met un
          pansement pour ne pas saigner. On pourra t’enlever le pansement quand on sera sûr que le
          petit trou fait par l’aiguille sera rebouché, cela se fait tout seul en quelques heures.</p>

          <p>Pour faire passer des liquides (par exemple des médicaments ou bien du sang si on te fait
          une transfusion) d’une poche plastique directement dans ton sang, les soignants utilisent un
          cathéter. C’est un petit tuyau fin en plastique qu’on va installer dans une de tes veines. <br>
          Le cathéter reste sur ton bras pendant plusieurs jours ou semaines et est fermé par un petit
          bouchon. Cela évite de devoir te piquer à chaque fois que l’infirmière a besoin de te faire
          passer des médicaments ou du sang. <br>
          Un pansement est mis sur le cathéter pour le garder bien propre et qu’il ne bouge pas. Ce
          pansement est changé très régulièrement. On l’enlève, on nettoie ta peau avec du
          désinfectant et on en remet un nouveau pansement propre. </p>

          <p>Pose toutes tes questions à une infirmière ou à d’autres soignants si tu veux bien
          comprendre tout ça.</p>

          <p>Tu peux aussi découvrir à quoi ressemble le matériel utilisé pour la prise de sang, la pose du
          cathéter et le changement de pansement dans ce mini-jeu.</p>

          <div v-if="$isDesktop()" class="box-game">
            <div class="content-game">
              <godot-game
                v-bind="gameInfos"
                @game_finished="endGame"
              />
            </div>
          </div>
          <div v-else>
            <div class="bt-game-mobile chimio">
              <bouton href="/games/decouverte/index.html">Accéder au jeu</bouton>
            </div>
          </div>

          <div class="grid-x grid-margin-x">
            <div class="small-12 cell">
              <h3>Les ressources complémentaires</h3>
            </div>

            <div v-for="fiche in fiches" class="small-12 medium-6 large-4 cell">
              <item-fiche
                :lien="fiche.url"
                :titlebox="fiche.title"
                :type-item="fiche.type">
                {{ fiche.content }}
              </item-fiche>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton.vue'
  import ItemFiche from '@/components/ItemFiche'
  import GodotGame from '@/components/GodotGame'

  import splashFLE from '@/assets/images/games/splash/splash-fle.jpg'
  import splashGame from '@/assets/images/games/splash/splash-catheter.jpg'

  import FichesDB from '@/datas/fiches'
  export default {
    props: ['gameId'],
    components: { TitlePage, Bouton, ItemFiche, GodotGame },
    data () {
      const me = this.$store.state.me
      const playerInfos = {
        gender: (me.gender === 'H' ? 'boy' : 'girl'),
        playerName: `${me.first_name} ${me.last_name}`,
      }
      return {
        gameInfos: {
          pck: 'jeu-catheter',
          engineVersion: 'full-3.2.1',
          splashStack: [
            {
              outerBarColor: '#01b1c8',
              innerBarColor: '#e43516',
              backgroundColor: '#FFF',
              duration: 2000,
              splashUrl: splashFLE
            },
            {
              outerBarColor: '#466C91',
              innerBarColor: '#5FABE3',
              backgroundColor: '#000',
              duration: 2000,
              splashUrl: splashGame
            },
          ],
          playerInfos
        },
        fichesIds: [14],
        fiches: []
      }
    },
    computed: {
      currentUser() {
        return this.$store.state.me
      }
    },
    async mounted () {
      const fichesDB = await FichesDB();
      this.fiches =  this.fichesIds.map((fid) => fichesDB.find(f => f.id === fid) )
    },
    methods: {
      endGame() {
        if (this.currentUser.account_type === 'child') {
          this.$store.dispatch('playGame', this.gameId)
        }
      }
    }
  }
</script>
